<!-- 运维视图 -->
<template>
    <el-row id="content" style="overflow-x: hidden;overflow-y: auto;">
        <el-row>
            <el-card class="box-card">
                <operation-board-notice ref="notice" @department-id-change="handleDepartmentIdChange"
                                        :start-date-time="startDateTime" :end-date-time="endDateTime">
                </operation-board-notice>
                <operation-board-duty :duties="duties" @after-add="handleAfterAdd" @after-accept="handleAfterAccept"
                                      @after-handover="handleAfterHandover">
                </operation-board-duty>
            </el-card>
        </el-row>
        <el-row :gutter="10" style="margin-top:10px;">
            <el-col :span="10">
                <operation-board-order :duty="duty" :params="params">
                </operation-board-order>
            </el-col>
            <el-col :span="14">
                <operation-board-ticket :params="params" :logbook="logbook">
                </operation-board-ticket>
            </el-col>
        </el-row>

        <el-row :gutter="10" style="margin-top:10px;">
            <el-col :span="10">
                <operation-board-handover-tool :department-id="departmentId" :logbook="logbook"
                                               @after-confirm="handleAfterConfirmHandoverTools">
                </operation-board-handover-tool>
            </el-col>
            <el-col :span="14">
                <operation-board-handover-matter :department-id="departmentId" :logbook="logbook">
                </operation-board-handover-matter>
            </el-col>
        </el-row>

        <el-row :gutter="10" style="margin-top:10px;">
            <el-col :span="10">
                <operation-board-duty-log :logbook="logbook">
                </operation-board-duty-log>
            </el-col>
            <el-col :span="14">
                <operation-board-duty-accept-remark :duties="duties">
                </operation-board-duty-accept-remark>
            </el-col>
        </el-row>
    </el-row>
</template>

<script>
    import "@/assets/css/athub-v3.css";
    import OperationBoardNotice from './operation-board-notice';
    import OperationBoardDuty from './operation-board-duty';
    import OperationBoardOrder from './operation-board-order';
    import OperationBoardTicket from './operation-board-ticket';
    import OperationBoardDutyLog from './operation-board-duty-log';
    import OperationBoardHandoverMatter from './operation-board-handover-matter';
    import OperationBoardHandoverTool from './operation-board-handover-tool';
    import OperationBoardDutyAcceptRemark from './operation-board-duty-accept-remark';
    import {getWorkScheduleLogbook,} from "@/views/board/operation/operation-board-duty-service";
    import CommonApi from "@/api/common";

    export default {
        name: "operation-board-index",
        components: {
            OperationBoardNotice,
            OperationBoardDuty,
            OperationBoardOrder,
            OperationBoardTicket,
            OperationBoardDutyLog,
            OperationBoardHandoverMatter,
            OperationBoardHandoverTool,
            OperationBoardDutyAcceptRemark,
        },
        data() {
            return {
                departmentId: null,

                // 值班
                duty: null,
                duties: {
                    first: null,
                    second: null,
                },

                params: null,
            };
        },
        computed: {
            logbook() {
                let duty = this.duty;
                return duty != null ? duty.logbook : null;
            },
            startDateTime() {
                let duty = this.duty;
                return duty != null ? duty.startDateTime : null;
            },
            endDateTime() {
                let duty = this.duty;
                return duty != null ? duty.endDateTime : null;
            },
        },
        watch: {
            duties: {
                deep: true,
                immediate: true,
                async handler(duties) {
                    this.duty = duties.first;
                    this.loadOrderParams();
                },
            },
        },
        methods: {
            handleDepartmentIdChange(departmentId) {
                this.departmentId = departmentId;

                this.loadDuties();
            },

            async load() {
                this.$refs.notice.load();
            },

            async loadDuties() {
                let departmentId = this.departmentId;
                this.duties = await getWorkScheduleLogbook(departmentId);
            },

            async loadOrderParams() {
                let params = null;
                let duty = this.duty;
                if (duty != null) {
                    let deptIds = [duty.departmentId];
                    let rooms = await CommonApi.getRoomsByDeptIds(deptIds);
                    let roomIds = rooms.map(e => e.id);
                    let dcNums = rooms.map(e => e.dcNum);
                    let startDate = duty.startDateTime;
                    let endDate = duty.endDateTime;
                    let leaders = duty.members.map(e => e.employeeCode);
                    params = {
                        roomids: roomIds,
                        dcnums: dcNums,
                        startdate: startDate,
                        enddate: endDate,
                        leaders: leaders,
                    }
                }
                this.params = params;
            },

            handleAfterAdd(success) {
                if (success) {
                    this.loadDuties();
                }
            },

            handleAfterAccept(success) {
                if (success) {
                    this.loadDuties();
                }
            },

            handleAfterHandover(success) {
                if (success) {
                    this.loadDuties();
                }
            },

            handleAfterConfirmHandoverTools(success) {
                if (success) {
                    this.loadDuties();
                }
            },
        },
        mounted() {
            this.load();
        },
    }
</script>

<style scoped>

</style>
